import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';

import { NgbModal, NgbModalOptions, ModalDismissReasons } from '@ng-bootstrap/ng-bootstrap';
import { DialogComponent } from '../features/dialog/dialog.component';


@Injectable()
export class DialogService {
  modalOption: NgbModalOptions = {}
  constructor(private modalService: NgbModal) { }

  public confirm(
    title: string,
    message: string,
    btnOkText: string = 'Yes',
    btnCancelText: string = 'No',
    btnLogOut: string = 'LOGOUT',

    dialogSize: 'sm' | 'lg' = 'lg'): Promise<boolean> {
    this.modalOption.backdrop = 'static';
    this.modalOption.keyboard = false;
    const modalRef = this.modalService.open(DialogComponent, this.modalOption );

    modalRef.componentInstance.title = title;
    modalRef.componentInstance.message = message;
    modalRef.componentInstance.btnOkText = btnOkText;
    modalRef.componentInstance.btnCancelText = btnCancelText;
    modalRef.componentInstance.btnLogOut = btnLogOut;

    return modalRef.result;
  }

}



// WEBPACK FOOTER //
// ./src/app/service/dialog.service.ts